import React from "react"
import PropTypes from "prop-types"
import { Redirect, Route, Switch } from "react-router-dom"
import { AppContainer } from "components/containers/app/AppContainer"
import LoginContainer from "components/containers/login/LoginContainer"
import "css/transitions.css"
import RegisterWizard from "components/views/fle/register/RegisterWizard"
import { FadeTransition } from "./molecules/Molecules"
import ResetPasswordContainer from "../containers/login/ResetPasswordContainer"
import RequestResetPasswordContainer from "../containers/login/RequestResetPasswordContainer"
import ResetPasswordSuccess from "./login/ResetPasswordSuccess"
import MerchantDeclineContainer from "../containers/merchantdecline/MerchantDeclineContainer"
import SignUp from "pages/signup"
import SignUpSuccess from "pages/signup-success"
import SignUpFindAccount from "pages/signup-find-account"
import SignUpFindAccountSuccess from "pages/signup-find-account-success"
import SignUpGetHelp from "../../pages/signup-get-help"
import SignUpGetHelpSuccess from "../../pages/signup-get-help-success"
import SignUpEmployeeAlreadyRegistered from "../../pages/signup-employee-already-registered"

const Root = ({ loggedIn }) => (
  <div>
    {loggedIn ? (
      <FadeTransition>
        <AppContainer key="app" />
      </FadeTransition>
    ) : (
      <Switch>
        <Route
          path="/signup"
          render={() => (
            <FadeTransition>
              <SignUp />
            </FadeTransition>
          )}
        />
        <Route path="/signup-success" component={SignUpSuccess} />
        <Route path="/signup-find-account" component={SignUpFindAccount} />
        <Route path="/signup-find-account-success" component={SignUpFindAccountSuccess} />
        <Route path="/signup-get-help" component={SignUpGetHelp} />
        <Route path="/signup-get-help-success" component={SignUpGetHelpSuccess} />
        <Route path="/signup-employee-already-registered" component={SignUpEmployeeAlreadyRegistered} />
        <Route path="/register/:guid" component={RegisterWizard} />
        <Route path="/reset-password-success" component={ResetPasswordSuccess} />
        <Route path="/reset-password/:guid" component={ResetPasswordContainer} />
        <Route path="/request-reset-password" component={RequestResetPasswordContainer} />
        <Route path="/confirm/:token" component={MerchantDeclineContainer} />
        <Redirect exact path="/sign-up" to="/signup" />
        {/* This needs to stay on the bottom since it doesn't have a path and will override any routes declared below it. */}
        <Route
          render={() => (
            <FadeTransition>
              <LoginContainer key="login" />
            </FadeTransition>
          )}
        />
      </Switch>
    )}
  </div>
)

Root.propTypes = {
  loggedIn: PropTypes.bool.isRequired
}

export default Root
